import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "wald-popia-consent";

export const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!window.localStorage.getItem(KEY)) {
      setVisible(true);
    }
  }, []);
  const accept = () => {
    window.localStorage.setItem(KEY, "accepted");
    setVisible(false);
  };
  const decline = () => {
    window.localStorage.setItem(KEY, "declined");
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <div
      data-testid="consent-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-40 border border-border bg-card p-5"
    >
      <div className="eyebrow mb-2">POPIA · Cookie Notice</div>
      <p className="text-sm opacity-80 leading-relaxed">
        We use minimal cookies for analytics and to remember your theme preference. Read our{" "}
        <Link to="/privacy-policy" className="copper-link underline underline-offset-2">Privacy Policy</Link>.
      </p>
      <div className="mt-4 flex gap-2">
        <button data-testid="consent-accept" onClick={accept} className="btn-copper text-xs py-2 px-4">Accept</button>
        <button data-testid="consent-decline" onClick={decline} className="btn-outline text-xs py-2 px-4">Decline</button>
      </div>
    </div>
  );
};
